import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from '../components/LandingPage';
import ChatLogsPage from './ChatLogsPage';
import TranslateLogsPage from './TranslateLogsPage';
import LoginPage from './LoginPage';
import NotFoundPage from './NotFoundPage';
import QueryClassificationPage from './queryclassificationPage';
import MasterDashboard from '../components/MasterDashboard/MasterDashboard';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Landing page */}
      <Route path="/" element={<LandingPage />} />
      
      {/* Main chat logs route */}
      <Route path="/chatlogs" element={<ChatLogsPage />} />
      
      {/* Translation logs route */}
      <Route path="/translatelogs" element={<TranslateLogsPage />} />
      
      {/* Alternative translate route */}
      <Route path="/translate" element={<TranslateLogsPage />} />
      
      {/* query_classification  route */}
      <Route path="/queryclassificationlogs" element={<QueryClassificationPage />} />
      
      {/* Master Dashboard route */}
      <Route path="/master-dashboard" element={<MasterDashboard />} />
      
      {/* Login route */}
      <Route path="/login" element={<LoginPage />} />
      
      {/* Catch all other routes */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes; 